import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UserAvailableLocalesRequest } from '../../../api/types';
import { changeUserAvailableLocales } from '../api/usersApi';
import { ADMIN_USERS_QUERY_KEY } from './useAdminUsers';

// PARA-138, AC-3: инвалидирует ['admin','users'] после успешного изменения
// доступных локалей.
export function useChangeUserAvailableLocales() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, payload }: { userId: number; payload: UserAvailableLocalesRequest }) =>
      changeUserAvailableLocales(userId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
    },
  });
}
